import { useNavigate } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center">
        <XCircle size={56} className="mx-auto text-stone-500 mb-4" />
        <h1 className="font-display uppercase text-3xl font-bold">Checkout cancelled</h1>
        <p className="text-stone-400 mt-2 text-sm">
          No charge was made. You can pick up right where you left off any time.
        </p>
        <button
          onClick={() => navigate("/portal/my-clips")}
          className="btn-primary mt-6 inline-flex items-center gap-2 text-sm"
          data-testid="back-to-clips-cancel"
        >
          <ArrowLeft size={14} /> Back to My Clips
        </button>
      </div>
    </div>
  );
}
